// import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
import { PhoneNumberUtil } from "google-libphonenumber";
const phoneUtil = PhoneNumberUtil.getInstance();

let createBranchServiceValidationForm = yup.object().shape({
  code: yup
    .string()
    .required("Code is required")
    .min(3, "Code must be at least 3 characters")
    .max(20, "Code must be at most 20 characters")
    .notOneOf(["admin", "root", "superuser"], "This username is not allowed"),
  name: yup.string().required("Full Name is required"),
  primary_email: yup.string().email().required("Email is required"),
  primary_contact: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Primary contact is required"),
  vat_pan: yup.string().required("VAT/PAN is required"),
});
export default createBranchServiceValidationForm;
